import {
  keepPreviousData,
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query'
import { getShifts, GetAdminShiftsParams } from 'api/shifts'
import { WorkShift } from 'api/typings'
import { listShiftsKey } from './keys'

/**
 * Fetch admin shifts via the REST dispatch endpoint.
 * Replaces the legacy getShifts/useShifts GraphQL flow.
 */
export function useShifts(
  params: GetAdminShiftsParams,
  options?: Pick<
    Parameters<
      typeof useQuery<WorkShift[], Error, WorkShift[], readonly unknown[]>
    >[0],
    'retry' | 'initialData' | 'enabled' | 'placeholderData'
  >
): UseQueryResult<WorkShift[]> {
  return useQuery({
    queryKey: listShiftsKey(params),
    queryFn: () => getShifts(params),
    retry: false,
    placeholderData: keepPreviousData,
    ...options,
  })
}
